var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('br'),_c('iframe',{attrs:{"title":"Report Section","width":"100%","height":"800","src":"https://app.powerbi.com/reportEmbed?reportId=0f3afc60-9274-4e6c-9531-bc098ba1f94a&autoAuth=true&ctid=a7c8d2b8-91dc-4f55-a75f-5fe194c917a7","frameborder":"0","allowFullScreen":"true"}})])])
}]

export { render, staticRenderFns }